module.exports = __webpack_public_path__ + "media/registry_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/registry_2400.jpg
// module id = 35
// module chunks = 0